var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#162B33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 73.23V40L17.5 38.75V73.23C16.88 74.93 16.25 76.81 16.25 77.5C16.25 78.88 17.37 80 18.75 80C20.13 80 21.25 78.88 21.25 77.5C21.25 76.81 20.63 74.94 20 73.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 47.5099V66.8499C75 67.7599 74.51 68.61 73.71 69.04C66.66 72.85 58.58 75.01 50 75.01C41.42 75.01 33.34 72.84 26.29 69.04C25.49 68.61 25 67.7599 25 66.8499V47.5099L50 60.0099L75 47.5099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.79 15.9L86.42 33.22C87.89 33.96 87.89 36.06 86.42 36.8L50 55.01L13.58 36.79C12.11 36.05 12.11 33.95 13.58 33.21L48.21 15.9C49.34 15.34 50.66 15.34 51.79 15.9Z",
    fill: "#E2F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9996 55.42L13.4096 37.13C12.5996 36.73 12.0996 35.91 12.0996 35.01C12.0996 34.1 12.5996 33.29 13.4096 32.89L48.0396 15.56C49.2696 14.95 50.7296 14.95 51.9496 15.56L86.5796 32.88C87.3896 33.29 87.8896 34.1 87.8896 35C87.8896 35.9 87.3896 36.72 86.5796 37.12L49.9896 55.42H49.9996ZM49.9996 15.85C49.4396 15.85 48.8896 15.98 48.3796 16.23L13.7496 33.55C13.1896 33.83 12.8496 34.37 12.8496 35C12.8496 35.63 13.1896 36.17 13.7496 36.45L49.9996 54.58L86.2496 36.45C86.8096 36.17 87.1496 35.63 87.1496 35C87.1496 34.37 86.8096 33.83 86.2496 33.55L51.6196 16.23C51.1096 15.98 50.5596 15.85 49.9996 15.85Z",
    fill: "#4782FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 47.51L50 60.01L25 47.51V42.5L50 55L75 42.5V47.51Z",
    fill: "#4782FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.94aa200897d02974fc98a73c30f26d38.svg";
export { ForwardRef as ReactComponent };